<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="desc" style='display: flex; margin-right: 30px;'>
        <span class="label-tit" style='width: 100px' >입고구분</span>
        <b-select class="select " v-model="form.inType">
          <option value='' label="선택">선택</option>
          <option
            v-for="item in combos['inType']"
            :key="item.key"
            :value="item.key"
            v-text="item.value"/>
        </b-select>
      </div>
      <div class="btn-type1" style="">
        <button class="btn-size btn-gray btn-space" @click="save()">
        <span class="btn-icon">
            <i class="fas fa-save"></i>
        </span>
          입고저장
        </button>
        <button class="btn-size btn-gray" @click="goSearch()">
        <span class="btn-icon">
            <i class="fas fa-search"></i>
        </span>
          검색
        </button>
      </div>

      <div class="pop-content-search">
        <el-form size="mini" @submit.prevent>
          <el-row :gutter="24">
            <el-col :span="5">
              <el-form-item label="제조사" label-width="60px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" style="margin-left:-40px;">
              <el-row>
                <el-form-item label="제품군" label-width="120px">
                  <el-col :span="12">
                    <el-select v-model="form.itemGroup" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['itemGroup']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subCatId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="구분" label-width="60px">
                <el-input v-model="form.description"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="품번" label-width="60px">
                <el-input v-model="form.itemCd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="품명" label-width="60px">
                <el-input v-model="form.itemNm"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="grid-wrap">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                style="width: 100%; height: 330px;"
                class="ag-theme-alpine"
                :framework-components="frameworkComponents"
                :column-defs="columnDefs"
                :grid-options="gridOptions"
                :row-data="rowData"
                :default-col-def="defaultColDef"
                :enableRangeSelection="true"
                :stopEditingWhenCellsLoseFocus="true"
                @grid-ready="onGridReady"/>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>


<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';

import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";


function _url(...args) {
  args = args.map(x => String(x || '').trim().replace(/^\/*|\/*$/g, ''))
  args = args.filter(x => x)
  return args.join('/')
}


export default {
  props: {
    data: {
      Type: Object
      , required: false
    },
  },
  components: {Layout, AgGridVue},
  data() {
    return {
      title: '자재입고추가등록',
      form: {
        companyId : 'CENTERLINK',
        maker : '',              // 제조사
        itemGroup : '',          // 제품군
        description : '',
        useModelNm : '',
        itemCd : '',             // 품번
        itemNm : '',             // 품명
        asAgentId : '',
        subCatId: '',            // 제품군 상세
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : '',
        inType: '',
      },
      combos: {
        'maker' : [],
        'itemGroup' : [],
        'subCatId' : [],
        'inType' : [],
      },
      changeCatIdShow : false,
      // AG-GRID OPTION [START]
      rowData:[],
      rowDataOrg:[], /** 조회후 데이타 백업 */
      gridOptions: {},
      frameworkComponents : {
        checkBox: CheckboxCellRenderer,
      },
      columnDefs:[
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'제조사', field:'makerNm', width:130, cellStyle : {textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:130, cellStyle : {textAlign: 'center'}},
        {headerName:'품번', field:'itemCd', width:180, cellStyle : {textAlign: 'left'}},
        {headerName:'품명', field:'itemNm', width:200, cellStyle : {textAlign: 'left'}},
        {headerName:'현재수량', field:'asIsGoodQty', width:120, cellStyle : {textAlign: 'right'}},
        {headerName:'수량', field:'goodQty', width:80, cellStyle : {textAlign: 'right'}, editable: true},
        {headerName:'선택', field: 'chk', width: 80, cellRenderer: 'checkBox', 
          cellRendererParams: {
              trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
            , disable: false
          },
        },
      ],
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      // AG-GRID OPTION [END]
    }
  },
  mounted() {
    this.getCombo()
    this.getConfigValue()
  },
  destroyed() {
    //ModalSlot open z-index change
    //$('.lnb').css('z-index', '7');
  },
  methods: {
    changeTab(params) {
      this.viewer = params.tabId;
    },
    closeModal() {
      console.log(this.$parent)
      this.$parent.close();
      this.$parent.$parent.goOpen();
    },
    handleNodeClick(data) {
      console.log(data);
    },
    onGridReady(){

    },
    getCombo() {
      this.getMakerCombo();
      this.getItemGroupCombo();
      this.getInTypeCombo();
    },
    getConfigValue() {
      this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
          .then(response => {
            this.form.asAgentId = response.data[0].configValue;
          });
    },
    getMakerCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 196} })
          .then(response => {
            this.combos['maker'] = response.data || []
          });
    },
    getItemGroupCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 143} })
          .then(response => {
            this.combos['itemGroup'] = response.data || []
          });
    },
    getInTypeCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 27818} })
          .then(response => {
            this.combos['inType'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '' ) this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subCatId'] = response.data || []
                  });
            });
      }
    },
    goSearch(){
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/mateEntering/popup/list"), {
        companyId : this.form.companyId,
        maker : this.form.maker,               // 제조사
        itemGroup : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? this.form.itemGroup : this.form.subCatId,          // 제품군
        description : this.form.description,
        useModelNm : this.form.useModelNm,
        itemCd : this.form.itemCd,             // 품번
        itemNm : this.form.itemNm,             // 품명
        asAgentId : this.form.asAgentId,
        subCatId: '',                        // 제품군 상세
        sortType : this.form.sortType,         // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : '',
        userId: this.$store.state.loginInfo.id
      }).then(response => {
            this.rowData = response.data.map(x => {
              x.asIsGoodQty = x.goodQty
              x.goodQty = 0;
              return x
            })
          }).finally(() => {
            this.$store.commit('finish')
      });
//          })
    },
    save() {
      let vm = this;
      if(vm.form.inType === '' || vm.form.inType === null || vm.form.inType === undefined)   {
        this.$swal({type: 'warning', text: '입고구분을 선택해 주십시오.'});
        return false;
      }
      // 양품만 넘겨주므로, 불량(badQty)은 0으로 해야 재고에 합산이 안됨...
      let list = this.rowData.filter(v => v.chk === 'Y')
                    .map(y=>{y.badQty=0; y.recycleQty=0; return y;});

      vm.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 저장 하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then(r => {
          if (r.value) {
            vm.$store.commit('loading')
            vm.result = list;

            for(let i=0; i<vm.result.length; i++){

              if(vm.result[i].goodQty <= 0){
                this.$swal({ type: 'success', text: '품번 : ' + vm.result[i].itemCd + '의 수량을 입력해주세요.' })
                vm.$store.commit('finish')
                return false;
              }

              Object.assign(
                  vm.result[i],
                  { inType: vm.form.inType },
                  { asAgentId: vm.form.asAgentId },
                  { description: vm.form.description }
              );
            }

            this.$http.post(_url(`/api/workMng/mateEntering/save`), vm.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '자재입고 추가 저장을 했습니다.' })
                      .then((result) => {
                        if (result.value) {
                          vm.goSearch();
                      }
                    });
              })
              .catch((e) => {
                this.$swal({ type: 'success', text: '자재입고 추가 저장을 실패 했습니다.' })
              })
              .finally(() => {
                vm.$store.commit('finish')
              });
          }
        }).catch((e) => {
        })
      } else {
        this.$swal({ type: 'info', text: '저장할 항목을 선택하세요.' });
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}

.btn-space {
  margin-right: 4px;
}
</style>